import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Collapse, Nav, Navbar, NavItem } from 'reactstrap';



const HeaderPublic = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [visible, setVisible] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [isCartview, setIsCartview] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsCartview(false);
        }
    };
    const handleScroll = () => {
        var scrollTop =
            (document.documentElement && document.documentElement.scrollTop) ||
            document.body.scrollTop;
        if (scrollTop > 100) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    return (
        <header id="site-header" className="header">
            <div id="header-wrap" className={`${visible ? 'fixed-header ' : ''}`}>
                <div className="container">
                    <div className="row">
                        <div className="col">
                            {/* Navbar */}
                            <Navbar className="navbar navbar-expand-lg navbar-light">
                                <Link className="navbar-brand logo text-primary mb-0" to="/" style={{ fontFamily: "Inter-SemiBold" }}>
                                    <span className="text-dark font-w-4">inspectiver</span>
                                </Link>
                                <button
                                    className="navbar-toggler"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target="#navbarNavDropdown"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                                    onClick={toggle}
                                >
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                <Collapse
                                    isOpen={isOpen}
                                    className="collapse navbar-collapse"
                                    navbar
                                >
                                    <Nav className="mx-auto navbar-nav">
                                        <NavItem>
                                            <Link className='nav-link' onClick={() => setIsOpen(false)} to="/blog-list">Blog</Link>
                                        </NavItem>
                                        <NavItem>
                                            <Link className='nav-link' onClick={() => setIsOpen(false)} to="/sample-reports">Sample Reports</Link>
                                        </NavItem>
                                        <NavItem>
                                            <Link className='nav-link' onClick={() => setIsOpen(false)} to="/inspector" >Become an Inspector</Link>
                                        </NavItem>
                                        <NavItem>
                                            <Link className='nav-link' style={{ fontWeight: 800 }} to="tel:+15624855485">
                                                <i className="la la-fw la-phone-volume me-1"></i>
                                                (562) 485-5485</Link>
                                            {/* <li className="mb-3">
                                                <a className="btn-link" href="tel:+15624855485">(562) 485-5485</a>
                                            </li> */}
                                        </NavItem>
                                        {/* <NavItem>
                                            <Link className='nav-link' onClick={() => setIsOpen(false)} to="/blog-new">Blog</Link>
                                        </NavItem> */}

                                    </Nav>

                                    <div className="d-sm-flex align-items-center justify-content-end">
                                        {/* For mobile: Full width button, for larger screens: smaller button */}
                                        <Link
                                            className="btn btn-primary btn-sm  d-sm-inline-block w-100 w-sm-auto"
                                            onClick={() => setIsOpen(false)}
                                            to="/login"
                                        >
                                            Inspector Login
                                        </Link>
                                    </div>
                                </Collapse>
                            </Navbar>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default HeaderPublic;
